(function () {
  'use strict';

  var POSTCODE_RE = /^[A-Z]{1,2}[0-9][0-9A-Z]?\s?[0-9][A-Z]{2}$/i;
  var EIRCODE_KEY = 'de_eircode';
  var FLOW_KEY = 'de_flow_active';
  var POLL_INTERVAL = 500;
  var POLL_MAX = 10;
  var CRASH_TTL = 2 * 60 * 1000;

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function formatPrice(raw) {
    return '£' + parseFloat(raw).toFixed(2);
  }

  // "NN11AA" -> "NN1 1AA" for display only
  function prettyPostcode(pc) {
    var s = String(pc || '').replace(/\s+/g, '').toUpperCase();
    if (s.length < 5) return s;
    return s.slice(0, s.length - 3) + ' ' + s.slice(-3);
  }

  function shippingQuery(pc) {
    return (
      'shipping_address%5Bzip%5D=' + encodeURIComponent(pc) +
      '&shipping_address%5Bcountry%5D=GB' +
      '&shipping_address%5Bfirst_name%5D=Estimator' +
      '&shipping_address%5Blast_name%5D=Quote'
    );
  }

  function cleanupShadowItems(cb) {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var idx = -1;
        for (var i = 0; i < items.length; i++) {
          var props = items[i].properties;
          if (props && props._estimator === 'true') { idx = i; break; }
        }
        if (idx === -1) { sessionStorage.removeItem(FLOW_KEY); cb(); return; }
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ line: idx + 1, quantity: 0 }),
        })
          .then(function () { sessionStorage.removeItem(FLOW_KEY); cb(); })
          .catch(function () { sessionStorage.removeItem(FLOW_KEY); cb(); });
      })
      .catch(function () { sessionStorage.removeItem(FLOW_KEY); cb(); });
  }

  function crashRecovery() {
    var ts = sessionStorage.getItem(FLOW_KEY);
    if (!ts) return;
    if (Date.now() - parseInt(ts, 10) < CRASH_TTL) {
      cleanupShadowItems(function () {});
    } else {
      sessionStorage.removeItem(FLOW_KEY);
    }
  }

  // --- Widget ---

  function DeliveryEstimator(root) {
    this.root = root;
    this.variantId = root.dataset.variantId;
    this.postcodeEl = root.querySelector('input[name="postcode"]');
    this.qtyEl = root.querySelector('input[type="number"]');
    this.btnEl = root.querySelector('.delivery-estimator__btn');
    this.resultEl = root.querySelector('.delivery-estimator__result');
    // Stores {line: N, quantity: Q} of any pre-existing cart line for this variant
    this._savedLine = null;
    // Total quantity of OTHER products in the basket at quote time.
    // null = unknown (cart fetch failed) -> suppress the context line.
    this._otherItemCount = null;
    // Qty the customer asked us to quote for
    this._lastQty = 1;

    var saved = sessionStorage.getItem(EIRCODE_KEY);
    if (saved) this.postcodeEl.value = prettyPostcode(saved);

    this._bind();
    this._subscribeVariant();
  }

  DeliveryEstimator.prototype._bind = function () {
    var self = this;
    self.btnEl.addEventListener('click', function () { self._estimate(); });
    self.postcodeEl.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); self._estimate(); }
    });
  };

  DeliveryEstimator.prototype._subscribeVariant = function () {
    var self = this;
    if (typeof subscribe !== 'function') return;
    subscribe('variant-change', function (event) {
      var v = event && event.data && event.data.variant;
      if (!v) return;
      self.variantId = String(v.id);
      self._setResult('');
    });
  };

  DeliveryEstimator.prototype._estimate = function () {
    var pc = (this.postcodeEl.value || '').trim().toUpperCase();
    var pcNoSpace = pc.replace(/\s+/g, '');
    var qty = Math.max(1, parseInt(this.qtyEl.value, 10) || 1);

    if (!POSTCODE_RE.test(pc)) {
      this._setResult(
        pc.length > 2
          ? '<p class="delivery-estimator__error">Please enter a valid UK postcode</p>'
          : ''
      );
      return;
    }

    var self = this;
    self._lastQty = qty;
    self._otherItemCount = null;
    self._lockUI();
    sessionStorage.setItem(FLOW_KEY, String(Date.now()));
    self._setResult('<p class="delivery-estimator__loading">Checking rates…</p>');

    // Step 1: zero out any existing cart line for this variant so Intuitive
    // Shipping only sees the estimator qty, not current qty + estimator qty.
    self._zeroExistingLine(qty, function () {
      self._addShadowItem(qty, function () {
        self._fetchRates(pcNoSpace, 0);
      });
    });
  };

  // Zero out any pre-existing non-shadow cart line for this variant.
  // Saves the line index + original qty so _restoreExistingLine can put it back.
  // Also records how many OTHER items are in the basket, for the result copy.
  DeliveryEstimator.prototype._zeroExistingLine = function (qty, cb) {
    var self = this;
    self._savedLine = null;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var found = null;
        var others = 0;

        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          var props = item.properties || {};
          var isShadow = props._estimator === 'true';
          var isThisVariant = String(item.variant_id) === String(self.variantId);

          if (isShadow) continue;

          if (isThisVariant) {
            if (!found) found = { line: i + 1, quantity: item.quantity };
          } else {
            others += item.quantity;
          }
        }

        self._otherItemCount = others;

        if (!found) { cb(); return; }

        self._savedLine = found;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ line: found.line, quantity: 0 }),
        })
          .then(function () { cb(); })
          .catch(function () {
            // If we can't zero it, proceed anyway (estimate may be slightly off)
            self._savedLine = null;
            cb();
          });
      })
      .catch(function () { self._otherItemCount = null; cb(); });
  };

  // Restore the zeroed-out cart line after the estimate is done.
  DeliveryEstimator.prototype._restoreExistingLine = function (cb) {
    var self = this;
    if (!self._savedLine) { cb(); return; }

    var saved = self._savedLine;
    self._savedLine = null;

    // Re-add the original item (the line number may have shifted after removing
    // the shadow item, so use add.js with the variantId rather than change.js).
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [{ id: parseInt(self.variantId, 10), quantity: saved.quantity }],
      }),
    })
      .then(function () { cb(); })
      .catch(function () { cb(); });
  };

  DeliveryEstimator.prototype._lockUI = function () {
    this.root.classList.add('delivery-estimator--loading');
    this.btnEl.disabled = true;
    this.postcodeEl.disabled = true;
    this.qtyEl.disabled = true;
  };

  DeliveryEstimator.prototype._unlockUI = function () {
    this.root.classList.remove('delivery-estimator--loading');
    this.btnEl.disabled = false;
    this.postcodeEl.disabled = false;
    this.qtyEl.disabled = false;
  };

  DeliveryEstimator.prototype._addShadowItem = function (qty, cb) {
    var self = this;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [{ id: parseInt(self.variantId, 10), quantity: qty, properties: { _estimator: 'true' } }],
      }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart/add failed: ' + res.status);
        return res.json();
      })
      .then(function () { cb(); })
      .catch(function (err) {
        console.error('[delivery-estimator] cart/add:', err);
        sessionStorage.removeItem(FLOW_KEY);
        self._restoreExistingLine(function () {
          self._unlockUI();
          self._setResult('<p class="delivery-estimator__error">Unable to retrieve delivery rates. Please try again.</p>');
        });
      });
  };

  DeliveryEstimator.prototype._fetchRates = function (pc, attempt) {
    var self = this;
    fetch('/cart/shipping_rates.json?' + shippingQuery(pc), { credentials: 'same-origin' })
      .then(function (res) {
        if (res.status === 202) {
          if (attempt >= POLL_MAX) throw new Error('timeout');
          setTimeout(function () { self._fetchRates(pc, attempt + 1); }, POLL_INTERVAL);
          return null;
        }
        if (res.status === 422) throw new Error('unprocessable');
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (data) {
        if (data === null) return;
        var rates = data && data.shipping_rates;
        self._cleanup(function () {
          self._renderRates(rates, pc);
        });
      })
      .catch(function (err) {
        var msg;
        if (err.message === 'timeout') {
          msg = '<p class="delivery-estimator__error">Rate calculation took too long. Please try again.</p>';
        } else if (err.message === 'unprocessable') {
          msg = '<p class="delivery-estimator__error">We couldn\'t find rates for this postcode. Please check and try again.</p>';
        } else {
          msg = '<p class="delivery-estimator__error">Unable to retrieve delivery rates. Please try again.</p>';
        }
        self._cleanup(function () { self._setResult(msg); });
        console.error('[delivery-estimator] fetchRates:', err);
      });
  };

  DeliveryEstimator.prototype._cleanup = function (cb) {
    var self = this;
    cleanupShadowItems(function () {
      self._restoreExistingLine(function () {
        self._unlockUI();
        if (cb) cb();
      });
    });
  };

  // Explains exactly what the quoted figure covers.
  DeliveryEstimator.prototype._contextLine = function (pc) {
    var other = this._otherItemCount;
    var qty = this._lastQty;
    var where = esc(prettyPostcode(pc));
    var thisItem = qty + ' × this product';
    var copy;

    if (other === null) {
      return '';
    }

    if (other > 0) {
      copy =
        'Covers ' + thisItem + ' <strong>plus the ' + other +
        (other === 1 ? ' item' : ' items') +
        ' already in your basket</strong>, delivered together to ' + where +
        '. Delivering this item on its own may cost less.';
    } else {
      copy = 'For ' + thisItem + ' delivered to ' + where + '.';
    }

    return (
      '<p class="delivery-estimator__context" ' +
      'style="margin:8px 0 0;font-size:12px;line-height:1.45;color:#5B6B7C;">' +
      copy + '</p>'
    );
  };

  DeliveryEstimator.prototype._renderRates = function (rates, pc) {
    if (!rates || !rates.length) {
      this._setResult(
        '<p class="delivery-estimator__no-rates" style="display:flex;justify-content:space-between;gap:12px;">' +
        '<span class="delivery-estimator__rate-name">Delivery</span>' +
        '<span class="delivery-estimator__rate-price">Calculated at checkout</span></p>'
      );
      return;
    }
    sessionStorage.setItem(EIRCODE_KEY, pc);
    var rate = rates[0];
    this._setResult(
      '<p class="delivery-estimator__rate-inline" style="display:flex;justify-content:space-between;gap:12px;margin:0;">' +
      '<span class="delivery-estimator__rate-name">' + esc(rate.name) + '</span>' +
      '<span class="delivery-estimator__rate-price">' + esc(formatPrice(rate.price)) + '</span></p>' +
      this._contextLine(pc)
    );
  };

  DeliveryEstimator.prototype._setResult = function (html) {
    this.resultEl.innerHTML = html;
  };

  crashRecovery();

  document.querySelectorAll('.delivery-estimator').forEach(function (el) {
    new DeliveryEstimator(el);
  });
})();